import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { TeacherInactivationDetailPage } from '@/features/teacherInactivations/pages/TeacherInactivationDetailPage';

export const Route = createFileRoute('/_auth/settings/teacher-inactivations/$requestId')({
  parseParams: ({ requestId }) => {
    const parsedId = Number(requestId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { requestId: parsedId };
  },
  component: function TeacherInactivationDetailRoute() {
    const { requestId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Teacher Inactivation">
        <Suspense fallback={<PageLoader />}>
          <TeacherInactivationDetailPage requestId={requestId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
